// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/SelectChannelLayoutPreset/styles.scss
// module id = 841
// module chunks = 0